import { DateTime } from "luxon";

export const WORLDS_OLDEST_PERSONS_BIRTHDATE = "1907-03-04";
export const PW_YOUNGEST_ACCEPTABLE_BIRTHDATE = DateTime.now()
  .minus({ months: 1 })
  .toISODate();
